var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21C7.9 21 7.01 20.11 7.01 19.01H10.99C10.99 20.11 10.1 21 9 21Z",
    fill: "#EFF3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 9V14.82L18 16.94V18H0V16.94L2.12 14.82V9C2.12 5.75 4.37 3.03 7.41 2.31V1.59C7.41 0.71 8.12 0 9 0C9.88 0 10.59 0.71 10.59 1.59V2.31C13.63 3.03 15.88 5.75 15.88 9Z",
    fill: "#EFF3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell-white.888013b7ad068ff2c80f8c1465271954.svg";
export { ForwardRef as ReactComponent };